module.exports = __webpack_public_path__ + "static/assets/89a814dd74462e6e53cca565b06b6e4b.svg";